import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas de "Sobre" — **todas públicas, sem guard**.
 *
 * Termos de uso e canal de contato são o que alguém procura **antes** de criar
 * uma conta; escondê-los atrás do login responderia à pergunta depois de a
 * decisão já ter sido tomada. É a mesma régua de `modules/content`.
 *
 * As três seções têm rota própria, e não são abas de uma tela só, pelo mesmo
 * motivo que as quatro de conteúdo: cada uma é compartilhável por link — "manda
 * aí os termos" é um pedido que circula colado num grupo de mensagens.
 */
const AboutPage = lazy(() => import('./routes/About.page'));
const TermsPage = lazy(() => import('./routes/Terms.page'));
const FaqPage = lazy(() => import('./routes/Faq.page'));
const ContactPage = lazy(() => import('./routes/Contact.page'));

export const aboutRoutes: RouteObject[] = [
  { path: 'about', element: <AboutPage /> },
  { path: 'about/terms', element: <TermsPage /> },
  { path: 'about/faq', element: <FaqPage /> },
  { path: 'about/contact', element: <ContactPage /> },
];
